import { render, staticRenderFns } from "./FamilyView.vue?vue&type=template&id=ede4d92c"
import script from "./FamilyView.ts?vue&type=script&lang=ts&external"
export * from "./FamilyView.ts?vue&type=script&lang=ts&external"
import style0 from "./FamilyView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports